import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import PlayerManagementTab from './AllianceManagement/PlayerManagementTab';
import StrikesTab from './AllianceManagement/StrikesTab';
import './css/AllianceManagement.css';
import { AdminTabs, PageShell, SectionCard } from '../components/ui';

const PLAYER_MANAGEMENT_TABS = [
  { value: 'players', label: 'Players' },
  { value: 'strikes', label: 'Strikes' },
];

const PlayerManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const validTabs = useMemo(() => new Set(PLAYER_MANAGEMENT_TABS.map((tab) => tab.value)), []);
  const requestedTab = searchParams.get('tab');
  const activeTab = validTabs.has(requestedTab) ? requestedTab : 'players';

  const setActiveTab = (nextTab) => {
    setSearchParams({ tab: validTabs.has(nextTab) ? nextTab : 'players' });
  };

  return (
    <PageShell maxWidth="xl">
      <div className="alliance-management-page">
        <AdminTabs tabs={PLAYER_MANAGEMENT_TABS} value={activeTab} onChange={setActiveTab} className="am-tab-menu" />

        <div className="am-tab-dropdown">
          <select value={activeTab} onChange={(e) => setActiveTab(e.target.value)}>
            <option value="players">Players</option>
            <option value="strikes">Strikes</option>
          </select>
        </div>

        <SectionCard className="am-tab-content" sx={{ p: { xs: 1.5, md: 2 } }}>
          {activeTab === 'players' && <PlayerManagementTab />}
          {activeTab === 'strikes' && <StrikesTab />}
        </SectionCard>
      </div>
    </PageShell>
  );
};

export default PlayerManagement;
